import type { ComponentProps } from 'react';
import {
  createLink,
  type AnyRouter,
  type LinkComponentProps,
  type RegisteredRouter,
} from '@tanstack/react-router';

// `navLink` is SmartLink's own prop: the router forwards it here with the
// rest, so it is dropped before the anchor. `...rest` carries the router's
// ref and data-* attributes (the onboarding anchors), which TSX admits
// without a prop declaration.
function Anchor({
  navLink: _navLink,
  ...rest
}: ComponentProps<'a'> & { navLink?: boolean | undefined }) {
  return <a {...rest} />;
}

const RouterLink = createLink(Anchor);

const NAV_ACTIVE = { className: 'active' };
const PLAIN_ACTIVE = {};

// The in-app link: `to`/`params`/`search` are checked against the route
// tree. `navLink` marks the current page's link with the `active` class;
// every other link stays unmarked. External hrefs are ExternalLink's. The
// generic signature is the router's LinkComponent one, spelled out so the
// component can be a function declaration.
export default function SmartLink<
  TRouter extends AnyRouter = RegisteredRouter,
  const TFrom extends string = string,
  const TTo extends string | undefined = undefined,
  const TMaskFrom extends string = TFrom,
  const TMaskTo extends string = '',
>(
  props: LinkComponentProps<
    typeof Anchor,
    TRouter,
    TFrom,
    TTo,
    TMaskFrom,
    TMaskTo
  >,
) {
  return (
    <RouterLink
      activeProps={props.navLink === true ? NAV_ACTIVE : PLAIN_ACTIVE}
      {...props}
    />
  );
}
